import React, { useEffect, useState } from "react";
import { Avatar, Divider, IconButton, Tooltip } from "@mui/material";
import { EditRounded } from "@mui/icons-material";
import moment from "moment";
import { DropLi } from "../../hooks";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MemberInfo = ({ member }) => {
  const { t } = useTranslation();
  const { Gender } = DropLi();
  const navigate = useNavigate();
  const [gender, setGender] = useState("");
  useEffect(() => {
    if (member) {
      var _gender = Gender.find((j) => j.id === member.gender);
      _gender && setGender(_gender.label);
    }
    return () => {
      setGender("");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [member]);

  const handleEdit = () => {
    navigate(`/member_form/${member.id}`);
  };

  return (
    <>
      {member && (
        <div className="d-grid bg-white p-10 br-25 gray-color">
          <div className="tx-right">
            <Tooltip title={t("Edit")}>
              <IconButton
                onClick={handleEdit}
                size="small"
                color="primary"
                sx={{ border: "1px solid var(--primarySM-color)" }}
              >
                <EditRounded className="fs-20 p-2" />
              </IconButton>
            </Tooltip>
          </div>
          <div className="d-flex j-center mb-10">
            <Avatar
              src={member.photo}
              alt="profile_pic"
              className="obj-cover"
              sx={{ width: "110px", height: "110px" }}
            />
          </div>
          <div className="d-grid gap-10 j-center">
            <div className="tx-center mb-15">
              <span className="fs-12 fw-5 bg-success white-color pl-10 pr-10 pt-5 pb-5 br-8 w-fit">
                {t("Active")}
              </span>
            </div>
            <div className="tx-center">
              <p className="fs-28 m-0 mb-5 fw-4">
                {member.firstName + " " + member.lastName}
              </p>
              <p className="fs-12 grayMD-color m-0">
                {t("MemberScince")}:{" "}
                {new Date(member.addDate).toLocaleDateString()}
              </p>
            </div>
          </div>
          <div className="p-10">
            <div className="d-flex a-center mt-40 mb-10">
              <span
                className="fs-12 fs-italic  tx-upp"
                style={{ width: "180px" }}
              >
                {t("PersonalDetails")}
              </span>
              <div className="bs-secondary w-100pr" />
            </div>
            <div className="d-flex flax-wrap j-between a-center mb-5">
              <span className="fs-15 mr-30">{t("Birthday")} :</span>
              <div className="d-grid tx-center">
                <span className="fs-15">
                  {member.dob &&
                    moment().diff(
                      moment(member.dob, "MM/DD/YYYY"),
                      "years"
                    )}{" "}
                  {t("YearsOld")}
                </span>
                <span className="fs-12 grayMD-color">{member.dob}</span>
              </div>
            </div>
            <Divider />
            <div className="d-flex flax-wrap j-between a-center mt-10 mb-10">
              <span className="fs-15 mr-30">{t("Gender")} :</span>
              <span className="fs-15">{gender}</span>
            </div>
            <Divider />
            <div className="d-flex flax-wrap j-between a-center mt-10 mb-10">
              <span className="fs-15 mr-30">{t("MemberStatus")} :</span>
              <span className="fs-15">
                {member.memberStatus && member.memberStatus.name}
              </span>
            </div>
            <Divider />
            <div className="d-flex flax-wrap j-between a-center mt-10 mb-10">
              <span className="fs-15 mr-30">{t("Nationality")} :</span>
              <span className="fs-15">{member.nationality}</span>
            </div>
            <Divider />

            <div className="d-flex flax-wrap j-between a-center mt-10 mb-10">
              <span className="fs-15 mr-30">{t("CivilId")} :</span>
              <span className="fs-15">{member.civilId}</span>
            </div>

            <Divider />
            <div className="d-flex flax-wrap j-between a-center mt-10 mb-10">
              <span className="fs-15 mr-30">{t("Mobile")} :</span>
              <a className="fs-15 link" href={`tel:${member.mobile}`}>
                {member.mobile}
              </a>
            </div>
            <Divider />
            <div className="d-flex flax-wrap j-between a-center mt-10 mb-10">
              <span className="fs-15 mr-30">{t("Email")} :</span>
              <a className="link fs-15" href={`mailto:${member.email}`}>
                {member.email}
              </a>
            </div>
            <Divider />
            <div className="d-flex flax-wrap j-between a-center mt-10 mb-10">
              <span className="fs-15 mr-30">RFID:</span>
              <span className="fs-15">{member.rfid}</span>
            </div>
            <Divider />
            <div className="d-grid mt-10 mb-10">
              <span className="fs-12 mr-30 mb-5">{t("Address")}:</span>
              <span className="fs-15">
                {member.address1} {member.address2 && `| ${member.address2}`}
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MemberInfo;
